(ns practitest.frontend.account-dashboard-settings.subs
  (:require
   [re-frame.core  :as re-frame]
   [clojure.string :as string]))

(re-frame/reg-sub
  :account-dashboard-settings/init-complete?
  (fn [db _]
    (:init-complete? db)))

(re-frame/reg-sub
 :account-dashboard-settings/get-list
 (fn [db [_ list-key filter-key]]
   (let [search-val   (if (nil? filter-key) "" (or (filter-key db) ""))
         dash-list    (list-key db)
         display-list (into (sorted-map-by (fn [a b] (compare (a dash-list) (b dash-list))))
                            (filter #(re-find (js/RegExp. (string/escape search-val {\) "\\)", \! "\\!", \@ "\\@", \# "\\#", \$ "\\$", \% "\\%", \^ "\\^", \& "\\&", \* "\\*", \( "\\(", \. "\\.", \? "\\?"}) "i") (last %)) dash-list))]
     display-list)))

(re-frame/reg-sub
 :account-dashboard-settings/account-message
 (fn [db _]
   (:account-message db)))

(re-frame/reg-sub
 :account-dashboard-settings/account-message-enable
 (fn [db _]
   (:account-message-enable db)))

(re-frame/reg-sub
 :account-dashboard-settings/markdown-support?
 (fn [db _]
   (:markdown-support? db)))

(re-frame/reg-sub
 :account-dashboard-settings/rtl?
 (fn [db _]
   (:rtl? db)))

(re-frame/reg-sub
 :account-dashboard-settings/get-message
 (fn [db [_ message-type]]
   (message-type db)))

(re-frame/reg-sub
 :account-dashboard-settings/get-search-val
 (fn [db [_ search-key]]
   (search-key db)))

(re-frame/reg-sub
 :account-dashboard-settings/db
 (fn [db _]
   db))
